import { call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  fetchUserDone,
  fetchUserError,
  fetchUserLoading,
  fetchUserSuccess,
  startTrialDone,
  startTrialError,
  startTrialLoading,
  startTrialSuccess,
} from '../actions/user';
import { FETCH_USER, START_TRIAL } from '../actions/actionTypes';
import { authApi } from '../api/AuthApi';
import { accountApi } from '../api/AccountApi';

export function* fetchUserSaga ({ checkOrgDashboard }) {
  try {
    yield put(fetchUserLoading());
    const user = yield call(authApi.authenticate, checkOrgDashboard);
    yield put(fetchUserSuccess(user));
  } catch (error) {
    yield put(fetchUserError(error));
  } finally {
    yield put(fetchUserDone());
  }
}

export function* startTrialSaga() {
  try {
    yield put(startTrialLoading());
    const user = yield call(accountApi.startTrial);
    yield put(startTrialSuccess());
    yield put(fetchUserSuccess(user));
  } catch (error) {
    yield put(startTrialError(error));
  } finally {
    yield put(startTrialDone());
  }
}

export function* watchFetchUserSaga () {
  yield takeLatest(FETCH_USER, fetchUserSaga);
}

export function* watchStartTrialSaga() {
  yield takeLatest(START_TRIAL, startTrialSaga);
}

export default [fork(watchFetchUserSaga), fork(watchStartTrialSaga)];
